import React, { useEffect } from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import { Calendar, Collab, CreditCard } from "@resources";
import { helpers } from "@shared";

const Welcome = () => {

    const navigate = useNavigate(), location = useLocation();

    const next = () => {
        helpers.navigateNext(location, navigate);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="page-content-wrapper">
            <h1 className="page-header">Welcome to Sunbound!</h1>
            <span className="page-subheader">Sunbound is the best way to pay for senior living each month</span>
            <div className="content-box shadow-sb">
                <h1 className="font-bold text-2xl">Sunbound Member Benefits</h1>
                <div className="flex flex-row items-center gap-x-3">
                    <div>
                        <h1 className="font-bold text-2xl">Pay your way</h1>
                        <span className="text-xl">Make payments via ACH or credit card. Set up auto-pay on your preferred date</span>
                    </div>
                    <CreditCard className="w-32 flex-none" />
                </div>
                <div className="w-full border-t-2 border-gray-300"></div>
                <div className="flex flex-row items-center gap-x-3">
                    <Collab className="w-32 flex-none" />
                    <div>
                        <h1 className="font-bold text-2xl">Pay collaboratively</h1>
                        <span className="text-xl">Invite family members to help pay the rent balance each month</span>
                    </div>
                </div>
                <div className="w-full border-t-2 border-gray-300"></div>
                <div className="flex flex-row items-center gap-x-3">
                    <div>
                        <h1 className="font-bold text-2xl">Pay over time</h1>
                        <span className="text-xl">Get extra time in the month to pay your rent balance if you prefer</span>
                    </div>
                    <Calendar className="w-32 flex-none" />
                </div>
            </div>
            <div className="page-action">
                <button type="button" className="btn btn-primary" onClick={next}>Continue</button>
            </div>
        </div>
    );
};

export default Welcome;
